<script>
  /**
   * 横田工業 日報 エディタ
   *  - 日報の編集
   *  - メンバーの追加/削除
   *  - 列の追加/削除
   */
  import { yokotaMemberList$ } from '../../store.js'
  import YokotaReportView from './YokotaReportView.svelte'
  import YokotaLogDialog from './YokotaLogDialog.svelte'

  export let date // 日付
  export let data

  let logDialog

  // メンバーリストをデータに追加
  $: if (!data?.memberList && $yokotaMemberList$)
    data = { ...data, memberList: $yokotaMemberList$ }
  // 列の数
  $: length = data?.logs?.length || 0

  // 作業時間 列追加
  const addLog = async () => {
    // data.logs 初期化
    if (!data?.logs) data.logs = []
    // ダイアログで列データ入力
    const entry = await logDialog.show()
    if (!entry) return
    // 列追加
    data.logs = [...data.logs, { date, ...entry }]
  }

  // 作業時間 列削除
  const removeLog = () => {
    // 確認プロンプト
    if (!window.confirm('削除してもよろしいですか？')) return
    // 右端の列を削除
    data.logs = data.logs.slice(0, -1)
  }

  // 臨時メンバー追加
  const addMember = () => {
    // 名前入力
    const newMember = window.prompt('追加する名前を入力:') || ''
    if (newMember === '') return // キャンセル
    if (!data?.memberList) data.memberList = [] // 初期化
    // メンバー追加
    data.memberList = [...data.memberList, newMember]
  }

  // メンバー削除
  const removeMember = () => {
    // 確認プロンプト
    if (!window.confirm('削除してもよろしいですか？')) return
    // 最後尾のメンバーを削除
    data.memberList = data.memberList.slice(0, -1)
  }
</script>

{#if data && data?.memberList}
  <YokotaReportView {data} isEditable={true}>
    <!-- 列の追加/削除ボタン -->
    <svelte:fragment slot="last-column" let:row>
      {#if row === 0}
        <td class="nowrap">
          <button
            type="button"
            class="button is-small is-primary"
            data-testid={`addLog`}
            on:click={addLog}>+</button
          >
          {#if length}
            <button
              type="button"
              class="button is-small is-danger"
              data-testid={`removeLog`}
              on:click={removeLog}>-</button
            >
          {/if}
        </td>
      {/if}
    </svelte:fragment>

    <!-- メンバー追加/削除ボタン -->
    <svelte:fragment slot="last-row">
      <tr>
        <td class="nowrap">
          <button
            type="button"
            class="button is-small is-primary"
            data-testid={`addMember`}
            on:click={addMember}>+</button
          >
          {#if data?.memberList?.length > $yokotaMemberList$?.length}
            <button
              type="button"
              class="button is-small is-danger"
              data-testid={`removeMember`}
              on:click={removeMember}>-</button
            >
          {/if}
        </td>
      </tr>
    </svelte:fragment>
  </YokotaReportView>

  <YokotaLogDialog memberList={data.memberList} bind:this={logDialog} />
{:else}
  <p>読み込み中...</p>
{/if}

<style>
  td {
    width: 80px;
  }

  td.nowrap {
    white-space: nowrap;
  }

  button {
    margin: 0;
  }
</style>
